module.exports = new __parcel__URL__("c1s9.c0a69f97.png").toString();